import axios from 'axios';
import XMLParser from 'react-xml-parser';
import * as CryptoJS from 'crypto-js';
import { logoutUrl } from './commonUrlConsts/commonUrlConsts';

const commonApiUrl = process.env.REACT_APP_COMMON_API_URL;
function getDefaultHeaders() {
  const accessToken = localStorage.getItem("accessToken");
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': 'en-US,en',
    'Authorization': `Bearer ${accessToken}`
  };
}

function commonApiService() {

  const generateToken = () => {
    // localStorage.clear();
    // window.location.href = window.location.origin;
  } 

  const generateMsAuthUrl = () => {
    const codeVerifier = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Base64);
    localStorage.setItem('codeVerifier',codeVerifier)
    const hash = CryptoJS.SHA256(codeVerifier);
    const codeChallenge = hash.toString(CryptoJS.enc.Base64)
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
    const authorizationEndpoint = process.env.REACT_APP_AUTH_URL;
    const resourceUri = process.env.REACT_APP_COMMON_API_RESOURCE;
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_REDIRECT_URL;
    return `${authorizationEndpoint}?resource=${resourceUri}&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256`;
  };

  const logOut = () => {
    localStorage.clear()
    window.location.href = logoutUrl;
  }

  const post = async (url, Obj) => {
    let headers = getDefaultHeaders()
    try {
      const response = await axios.post(url, JSON.stringify(Obj), {
        headers: headers,
      });
      if (response.status === 401) {
        generateToken();
      }

      const result = response.data;
      return result;
    } catch (error) {
      console.error('Error fetching data:', error);
      // return { success: false, error };
      return error?.response?.data;
    }
  };

  const postWithId = async (url, flag = null, id = null, routeExpand = null, obj = null) => {
    const oDataMovUrl = url;
    let oDataUrl;
    if (flag === null || flag === undefined || flag.toString() === '') {
      oDataUrl = `${oDataMovUrl}(${id})/${routeExpand}`;
    } else if (id === null || id === undefined || id.toString() === '') {
      oDataUrl = `${oDataMovUrl}`;
    } else {
      oDataUrl = `${oDataMovUrl}/${flag}(${id})/${routeExpand}`;
    }
    let headers = getDefaultHeaders()
    try {
      const options = {
        method: 'POST',
        headers: headers,
      };
      if (obj !== null) {
        options.data = JSON.stringify(obj);
      }
      const response = await axios(oDataUrl, options);
      if (response.status === 401) {
        generateToken();
      }
      if (response.status === 204) {
        return response.status;
      }
      const result = response.data;
      return result;
    } catch (error) {
      console.error('Error fetching data:', error);
      // return { success: false, error };
      return error?.response?.data;
    }
  };


  const put = async (mediaReadLink, etag, savedViewData) => {
    let headers = getDefaultHeaders()
    const etagData = etag.replace(/\\"/g, '"');
    if (etag !== 'All' && etag !== undefined && etag !== null) {
      headers['If-Match'] = etagData;
    }
    try {
      const response = await axios.put(
        mediaReadLink,
        JSON.stringify(savedViewData),
        {
          headers: headers,
        }
      );
      if (response.status === 401) {
        generateToken();
      }
      return response.data;
    } catch (error) {
      console.error('Error posting data:', error);
      return error?.response?.data;
    }
  };


  const patch = async (url, body = null, etag) => {
    let headers = getDefaultHeaders()
    const etagData = etag.replace(/\\"/g, '"');
    if (etag !== 'All' && etag !== undefined && etag !== null) {
      headers['If-Match'] = etagData;
    }
    try {
      const response = await axios.patch(url, JSON.stringify(body), {
        headers: headers,
      });
      if (response.status === 401) {
        localStorage.clear();
        window.location.href = window.location.origin;
      }
      const result = response.data;
      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        generateToken();
      } else if (error.response) {
        return error?.response?.data;
      } else {
        console.error('Error:', error);
        // return { success: false, error };
        return error?.response?.data;
      }
    }
  };



  const get = async (url, take, routeExpand, skipUrl, pageSize, etag) => {
    let headers = getDefaultHeaders()
    if (skipUrl === null || skipUrl === undefined || skipUrl.toString() === '') {
      let oDataUrl;
      let oDataMovUrl = url;
      if (!routeExpand && !take) {
        oDataUrl = `${oDataMovUrl}`
      } else if (!routeExpand) {
        oDataUrl = `${oDataMovUrl}?${take}`
      } else if (!take) {
        oDataUrl = `${oDataMovUrl}?${routeExpand}`
      } else {
        oDataUrl = `${oDataMovUrl}?${take}${routeExpand}`
      }


      if (pageSize !== 'All' && pageSize !== undefined && pageSize !== null) {
        headers['Prefer'] = `odata.maxpagesize=${pageSize}`;
      }
      if (etag !== 'All' && etag !== undefined && etag !== null) {
        const etagData = etag.replace(/\\"/g, '"');
        headers['If-Match'] = etagData;
      }
      try {
        const response = await axios.get(oDataUrl, {
          headers: headers,
        });
        if (response.status === 401) {
          generateToken();
        }
        const result = response.data;
        return result;
      } catch (error) {
        console.error('Error fetching data:', error);
        // return { success: false, error };
        return error?.response?.data;
      }
    }
    else {
      try {
        headers['Prefer'] = `odata.maxpagesize=${process.env.REACT_APP_MAXPAGESIZE}`;
        const response = await axios.get(skipUrl, {
          headers: headers,
        });
        if (response.status === 401) {
          generateToken();
        }
        const result = response.data;
        return result;
      } catch (error) {
        console.error('Error fetching data:', error);
        // return { success: false, error };
        return error?.response?.data;
      }
    }
  };


  const deleteData = async (url,id,param) => {  
    let headers = getDefaultHeaders()
    if (param && param['@odata.etag'] !== 'All' && param['@odata.etag'] !== undefined && param['@odata.etag'] !== null) {
      const etagData = param['@odata.etag'].replace(/\\"/g, '"');
      headers['If-Match'] = etagData;
    }
    let deleteUrl = `${url}(${id})`
    try {
      const response = await axios.delete(deleteUrl, {
        headers: headers,
      });

      if (response.status === 401) {
        generateToken();
      } else if (response.status === 204) {
        return response.status;
      }

      const result = response.data;
      return result;
    } catch (error) {
      console.error('Error deleting data:', error);
      // return { success: false, error };
      return error?.response?.data;
    }
  };

  const getCoordinates = async (data) => {
    const updatedData = await Promise.all(
      data.map(async (address) => {
        const startAddressString = `${address.startAddressCity || address.startCity}, ${address.startAddressPostCode || address.startPostCode}, ${address.startAddressCountry || address.startCountry}`;
        const endAddressString = `${address.endAddressCity || address.endCity}, ${address.endAddressPostCode || address.endPostCode}, ${address.endAddressCountry || address.endCounty}`;
  
        const startUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(startAddressString)}&format=json&addressdetails=1&limit=1`;
        const endUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(endAddressString)}&format=json&addressdetails=1&limit=1`;
  
        try {
          const [startResponse, endResponse] = await Promise.all([axios.get(startUrl), axios.get(endUrl)]);
  
          const startLocation = startResponse.data.length > 0 ? startResponse.data[0] : null;
          const endLocation = endResponse.data.length > 0 ? endResponse.data[0] : null;
  
          return {
            ...address,
            startLat: startLocation ? startLocation.lat : null,
            startLng: startLocation ? startLocation.lon : null,
            endLat: endLocation ? endLocation.lat : null,
            endLng: endLocation ? endLocation.lon : null,
          };
        } catch (error) {
          console.error('Error fetching coordinates for addresses:', startAddressString, endAddressString);
          return {
            ...address,
            startLat: null,
            startLng: null,
            endLat: null,
            endLng: null,
          };
        }
      })
    );

    return updatedData;
  };
  
  // const deleteSavedCustomView = async (param) => {
  //   const companyId = localStorage.getItem("companyId");
  //   const oDataMovUrl = `${commonApiUrl}companies(${companyId})/savedViews(${param.id})`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'DELETE',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //         "If-Match": param['@odata.etag'].replace(/\\"/g, '"')
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     if (response.status === 204) {
  //       return response.status;
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  // const callAPI = async (urlRoute, body = null, header = null) => {
  //   let response = null;
  //   try {
  //     const url = `${process.env.REACT_APP_COMMON_API_URL}` + urlRoute;
  //     const accessToken = localStorage.getItem("accessToken");
  //     const headers = {
  //       "Content-Type": "application/json",
  //       'Accept': 'application/json',
  //       'Authorization': `Bearer ${accessToken}`,
  //     };

  //     if (body)
  //       response = await axios.post(url, body, { headers: header ? header : headers });
  //     else
  //       response = await axios.get(url, { headers: header ? header : headers });

  //     if (response.status == 200)
  //       return response.data;

  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       generateToken();
  //     }
  //   }
  // }

  // const patchApiCall = async(urlRoute, body = null,etag, header = null) => {
  //   let response = null;

  //   try {
  //     const url = `${process.env.REACT_APP_COMMON_API_URL}` + urlRoute;
  //     const accessToken = localStorage.getItem("accessToken");
  //     const etagData = etag.replace(/\\"/g, '"');

  //     const headers = {
  //       "Content-Type": "application/json",
  //       'Accept': 'application/json',
  //       'Authorization': `Bearer ${accessToken}`,
  //       "If-Match": etagData
  //     };

  //     response = await axios.patch(url, body, { headers: header ? header : headers })

  //     return response.data;
  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       generateToken();
  //     } else {
  //       return error?.response?.data
  //     }
        
  //   }
  // }

  // const fetchApiData = async (take, compType, routeExpand, skipUrl, pageSize) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   const companyId = localStorage.getItem("companyId");
  //   if (skipUrl === null || skipUrl == undefined || skipUrl.toString() === '') {
  //     const oDataMovUrl = `${commonApiUrl}companies(${companyId})/${compType}?`;

  //     try {
  //       const init = {
  //         method: 'GET',
  //         accept: 'application/json',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //           'Authorization': `Bearer ${accessToken}`
  //         }
  //       };
  //       if (pageSize != 'All' || pageSize != undefined || pageSize != null) {
  //         init.headers['Prefer'] = `odata.maxpagesize=${pageSize}`
  //       }

  //       const oDataUrl = routeExpand ? `${oDataMovUrl}${take}${routeExpand}` : `${oDataMovUrl}${take}`;
  //       const response = await fetch(oDataUrl, init);
  //       if (response.status === 401) {
  //         generateToken();
  //       }
  //       const result = await response.json();
  //       return result;
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   }
  //   else {
  //     try {
  //       const init = {
  //         method: 'GET',
  //         accept: 'application/json',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //           'Authorization': `Bearer ${accessToken}`,
  //           'Prefer': `odata.maxpagesize=${process.env.REACT_APP_MAXPAGESIZE}`
  //         }
  //       };
  //       const response = await fetch(skipUrl, init);
  //       if (response.status === 401) {
  //         generateToken();
  //       }
  //       const result = await response.json();

  //       return result;
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   }
  // };

  // const fetchCaptionApiData = async (oDataUrl) => {
  //   const oDataMovUrl = `${commonApiUrl}${oDataUrl}`;
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const init = {
  //       method: 'GET',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };

  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //       return;
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const fetchApiDepotData = async (take, compType, routeExpand) => {
  //   const oDataMovUrl = `${commonApiUrl}${compType}?company=CRONUS%20International%20Ltd.&$top=100&$skip=0&$filter=depot eq true`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'GET',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const oDataUrl = routeExpand ? `${oDataMovUrl}${take}${routeExpand}` : `${oDataMovUrl}${take}`;
  //     const response = await fetch(oDataUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const fetchActionCodes = async () => {
  //   const oDataMovUrl = `${commonApiUrl}actionCodes?company=CRONUS%20International%20Ltd.&top=100&$skip=0`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'GET',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };

  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  const getODataMetadata = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Accept-Language': 'en-US,en',
        'Accept': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      };
      const response = await axios.get(`${commonApiUrl}$metadata?$schemaversion=2.0`, { headers }); // Fetch OData metadata (XML)
      const xml = new XMLParser().parseFromString(response.data);

      // const jsonData = xmlParser.xml2json(xmlData, { compact: true, spaces: 2 }); // Convert XML to JSON
      return xml;
    } catch (error) {
      if (error.response.status === 401) {
        generateToken();
      }
      console.error('Error fetching or converting OData metadata:', error);
    }
  }

  // const fetchVisibleColMetadata = async (id) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const url = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/userSettings(${id})/visibleColumnsMetadata`;
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     });

  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     if (!response.ok) {
  //       throw new Error(`Request failed with status ${response.status}`);
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   };
  // };

  // const getUrlShipment = async (id) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const url = `https://production2.navitrans.eu:8348/Dilx/api/navitrans/plb/v1.0/companies(c195304b-23ed-4677-a92c-90c7a93fe908)/movements(${id})/Microsoft.NAV.getUrlShipment`;
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //       body: null,
  //     });

  //     if (response.status === 401) {
  //       generateToken();
  //     }

  //     const responseData = await response.json();
  //     return responseData;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   };
  // };

  // const getUrlFile = async (id) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const url = `https://production2.navitrans.eu:8348/Dilx/api/navitrans/plb/v1.0/companies(c195304b-23ed-4677-a92c-90c7a93fe908)/movements(${id})/Microsoft.NAV.getUrlFile`;
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //       body: null,
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const responseData = await response.json();

  //     return responseData;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   };
  // };

  // const postSavedViewsData = async (objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/savedViews`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postPlanMovements = async (objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     // const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/planMovements?$expand=movementlines,action`, {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/planMovementsNew?$expand=movementlines,operationDetail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postContractOut = async (objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/contractOutMovements?$expand=movementlines,contractoutaction`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postPartialTripContractOut = async (id) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.contractOut`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: null,
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postChangeSequence = async (id, objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/routes(${id})/Microsoft.NAV.changeSequence`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     if (response.status === 204) {
  //       return response.status;
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postMoveUp = async (id, objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/routes(${id})/Microsoft.NAV.moveUp`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
     
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const postMoveDown = async (id, objData) => {
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/routes(${id})/Microsoft.NAV.moveDown`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
      
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const InsertHookOff = async (urlRoute, body = null, header = null) => {
  //   let response = null;
  //   try {
  //     const url = `${process.env.REACT_APP_COMMON_API_URL}` + urlRoute;
  //     const accessToken = localStorage.getItem("accessToken");

  //     const headers = {
  //       "Content-Type": "application/json",
  //       'Accept': 'application/json',
  //       'Authorization': `Bearer ${accessToken}`,
  //     };

  //     if (body)
  //       response = await axios.post(url, body, { headers: header ? header : headers });
  //     else
  //       response = await axios.get(url, { headers: header ? header : headers });

  //     // if (response.status == 200)
  //     return response

  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       generateToken();
  //     } else {
  //       return error?.response?.data;
  //     }
  //   }
  // }

  // const postSetFree = async (urlRoute, Obj = null, header = null) => {
  //   const url = `${process.env.REACT_APP_COMMON_API_URL}` + urlRoute;
  //   const accessToken = localStorage.getItem("accessToken");
  //   const headers = {
  //     'Content-Type': 'application/json',
  //     'Accept': 'application/json',
  //     'Authorization': `Bearer ${accessToken}`
  //   };
  //   try {
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       headers: header ? header : headers,
  //       body: JSON.stringify(Obj),
  //     });

  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     return error?.response?.data;
  //     console.error('Error fetching data:', error);
  //   }
  // }

  // const InsertDepot = async (url, Obj) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const response = await fetch(`${commonApiUrl}insertDepots?company=CRONUS%20International%20Ltd.&$expand=movementlines,operationDetail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(Obj),
  //     });

  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     return error?.response?.data;
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const updateReadLinkData = async (mediaReadLink, etag, savedViewData) => {
  //   const etagData = etag.replace(/\\"/g, '"');
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(mediaReadLink, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //         "If-Match": etagData
  //       },
  //       body: JSON.stringify(savedViewData),
  //     });

  //     if (response.status === 401) {
  //       generateToken();
  //     }

  //     if (response.status === 204) {
  //       return response.status;
  //     }
  //   } catch (error) {
  //     return error?.response?.data;
  //     console.error('Error posting data:', error);
  //   }
  // }

  // const fetchReadLinkData = async (mediaReadLink, etag) => {
  //   const etagData = etag.replace(/\\"/g, '"');
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(mediaReadLink, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //         "If-Match": etagData
  //       }
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     if (!response.ok) {
  //       throw new Error(`Request failed with status ${response.status}`);
  //     }
  //     const result = await response.json();

  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  // const fetchAllSavedViews = async (filterUrl) => {
  //   let commonUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/savedViews`;
  //   let savedViewApiUrl = filterUrl != null ? `${commonUrl}${filterUrl}` : commonUrl;
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(savedViewApiUrl, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();

  //       return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }


  // const fetchStatusColorCodeData = async () => {
  //   const url = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/movementStatuses`;
  //   const accessToken = localStorage.getItem("accessToken");

  //   try {
  //     const response = await fetch(url, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;

  //   } catch (error) {
  //     console.log('Error Fetching data:', error)
  //   }
  // }

  // const getMovementsQualification = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/movements(${id})/Microsoft.NAV.getQualificationToolTip`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }


  // const getMovementsInstructions = async (flag, id, filter) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/${flag}(${id})?$select=id&$expand=${filter}($select=description)`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'GET',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }

  // const fetchMovementReport = async (flag, id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/${flag}(${id})/Microsoft.NAV.reports`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const sendPartialTripToObc = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.sendTripOBC`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const changeRoute = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/routes(${id})/Microsoft.NAV.changeRoute`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const changeStatus = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/routes(${id})/Microsoft.NAV.changeStatus`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const transferGoodsFromPartialTrip = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.transferGoods`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const splitPartialTrip = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.splitTrip`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const insertBeginEndActionPartialTrip = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.insertBeginEndAction`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const regroupPartialTrip = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.regroupTrip`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'POST',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const deletePartialTrip = async (id) => {
  //   const oDataMovUrl = `${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})`;
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const init = {
  //       method: 'DELETE',
  //       accept: 'application/json',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       }
  //     };
  //     const response = await fetch(oDataMovUrl, init);
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };

  // const DeleteDepot = async (Obj, compType) => {
  //   try {
  //     const accessToken = localStorage.getItem("accessToken");
  //     const response = await fetch(`${commonApiUrl}deleteDepots?company=CRONUS%20International%20Ltd.&$expand=movementlines,operationDetail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(Obj),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     return { success: false, error }
  //   }
  // };

  // const DeleteHookOff = async (Obj, compType) => {
  //   try {
  //     const accessToken = localStorage.getItem("accessToken");
  //     const response = await fetch(`${commonApiUrl}deleteHookOff?company=CRONUS%20International%20Ltd.&$expand=movementlines,operationDetail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(Obj),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     return { success: false, error }
  //   }
  // };

  // const CustomHookOff = async (Obj, compType) => {
  //   try {
  //     const accessToken = localStorage.getItem("accessToken");
  //     const response = await fetch(`${commonApiUrl}customHookOff?company=CRONUS%20International%20Ltd.&$expand=movementlines,operationDetail`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(Obj),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     return { success: false, error }
  //   }
  // };

  // const InsertCustomHookOff = async (urlRoute, body = null, header = null) => {
  //   let response = null;
  //   try {
  //     const url = `${process.env.REACT_APP_COMMON_API_URL}` + urlRoute;
  //     const accessToken = localStorage.getItem("accessToken");

  //     const headers = {
  //       "Content-Type": "application/json",
  //       'Accept': 'application/json',
  //       'Authorization': `Bearer ${accessToken}`,
  //     };

  //     if (body)
  //       response = await axios.post(url, body, { headers: header ? header : headers });
  //     else
  //       response = await axios.get(url, { headers: header ? header : headers });

  //     // if (response.status == 200)
  //     return response

  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       generateToken();
  //     }
  //     return error?.response?.data;
  //   }
  // }

  // const postCalculateIncludingActionTimes = async (id, objData) => {
  //   const accessToken = localStorage.getItem("accessToken");
  //   try {
  //     const response = await fetch(`${commonApiUrl}companies(c195304b-23ed-4677-a92c-90c7a93fe908)/partialTrips(${id})/Microsoft.NAV.calculateIncludingActionTimes`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Accept': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`
  //       },
  //       body: JSON.stringify(objData),
  //     });
  //     if (response.status === 401) {
  //       generateToken();
  //     }
  //     const result = await response.json();
  //     return result;
  //   } catch (error) {
  //     console.error('Error posting data:', error);
  //   }
  // }

  return {
    get,
    post,
    patch,
    put,
    deleteData,
    postWithId,
    generateMsAuthUrl,
    logOut,
    // fetchApiData,
    getODataMetadata,
    getCoordinates,
    // postSavedViewsData,
    // fetchReadLinkData,
    // fetchAllSavedViews,
    // deleteSavedCustomView,
    // updateReadLinkData,
    // fetchStatusColorCodeData,
    // postPlanMovements,
    // callAPI,
    // patchApiCall,
    // getUrlShipment,
    // getUrlFile,
    // postContractOut,
    // postPartialTripContractOut,
    // InsertHookOff,
    // postSetFree,
    // fetchActionCodes,
    // fetchApiDepotData,
    // InsertDepot,
    // fetchMovementReport,
    // sendPartialTripToObc,
    // transferGoodsFromPartialTrip,
    // splitPartialTrip,
    // insertBeginEndActionPartialTrip,
    // regroupPartialTrip,
    // deletePartialTrip,
    // DeleteDepot,
    // DeleteHookOff,
    // fetchCaptionApiData,
    // getMovementsQualification,
    // getMovementsInstructions,
    // CustomHookOff,
    // InsertCustomHookOff,
    // postChangeSequence,
    // postMoveUp,
    // postMoveDown,
    // fetchVisibleColMetadata,
    // changeRoute,
    // changeStatus,
    // postCalculateIncludingActionTimes
  }
}



export default commonApiService;